<template>
    <div v-if="show" class="modal-overlay">
        <div class="modal-card">
            <div class="modal-header">
                <div>
                    <h3>Informações complementares</h3>
                    <p>{{ item?.nmcaption }}</p>
                </div>

                <button class="btn-close" @click="cancelar">×</button>
            </div>

            <textarea
                ref="textareaRef"
                v-model="texto"
                class="modal-textarea"
                rows="8"
                placeholder="Digite as informações complementares..."
            ></textarea>

            <div class="modal-actions">
                <button @click="cancelar">Cancelar</button>
                <button class="btn-confirm" @click="confirmar">Confirmar</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { nextTick, ref } from 'vue';

const show = ref(false);
const item = ref(null);
const texto = ref('');
const resolvePromise = ref(null);
const textareaRef = ref(null);

function showModal(itemParam) {
    item.value = itemParam;
    texto.value = itemParam?.informacoes || '';
    show.value = true;

    nextTick(() => {
        textareaRef.value?.focus();
    });

    return new Promise(resolve => {
        resolvePromise.value = resolve;
    });
}

function confirmar() {
    show.value = false;
    resolvePromise.value?.(texto.value);
}

function cancelar() {
    show.value = false;
    resolvePromise.value?.(null);
}

defineExpose({ showModal });
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(15, 23, 42, .45);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
}

.modal-card {
    width: min(760px, 100%);
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 18px 45px rgba(0, 0, 0, .25);
    padding: 16px;
}

.modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.modal-header h3 {
    margin: 0;
    font-size: 18px;
    color: #1f2937;
}

.modal-header p {
    margin: 4px 0 0;
    font-size: 13px;
    color: #6b7280;
    line-height: 1.35;
}

.btn-close {
    border: none;
    background: transparent;
    font-size: 26px;
    line-height: 1;
    cursor: pointer;
    color: #6b7280;
}

.modal-textarea {
    width: 100%;
    min-height: 180px;
    resize: vertical;
    line-height: 1.4;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 14px;
}
</style>